import type { StripeProducts } from '@racemap/sdk/schema/billing/StripeProducts';
import { useMemo } from 'react';
import {
  type Price,
  getProductPriceFactory,
} from '../../components/CostCalculator/getProductPriceFactory';
import { usePriceList } from './usePriceList';

export function useGetProductPrice({
  isReseller,
}: { isReseller?: boolean } = {}):
  | ((product: StripeProducts, quantity: number, tier?: number | null) => Price)
  | undefined {
  const { priceList } = usePriceList({ isReseller });
  return useMemo(() => getProductPriceFactory(priceList), [priceList]);
}
